module.exports = __webpack_public_path__ + "static/My Food Link-5d1b93540987ad997a289e9f45726e0c.svg";